/* eslint-disable no-unused-vars */
import { useCallback, useState } from 'react'
import { AxiosError } from 'axios'

import { t } from '@/i18n'
import api from '@/api/index'
import { useToast } from '@/hooks/index'

interface ISendForm<T> {
  path: string
  method: 'POST' | 'PUT' | 'DELETE'
  data: T
  callback?: (res?: T) => void
}

interface ISendFormOpts {
  showNotify?: boolean
}

export const useAPI = <T extends Record<string, any> | undefined>() => {
  const addToast = useToast()
  const [submitting, setSubmitting] = useState<boolean>(false)

  const sendForm = useCallback(
    ({ path, method, data, callback }: ISendForm<T>, opts?: ISendFormOpts) => {
      setSubmitting(true)
      const apiFn =
        method === 'POST'
          ? api.post
          : method === 'PUT'
          ? api.put
          : api.deleteSync

      apiFn<T>(path, data)
        .then((res: T) => {
          if (opts?.showNotify) {
            addToast('success', t('success'))
          }
          callback?.(res)
        })
        .catch((e: AxiosError) => {
          if (e.message) {
            addToast('error', e.message)
          }
          // @ts-ignore
          Object.entries(e.response?.data || {}).forEach(
            ([field, messages]) => {
              // @ts-ignore
              addToast('error', `${field}: ${messages.join(', ')}`)
            },
          )
          console.error({ e })
        })
        .finally(() => {
          setSubmitting(false)
          // window.location.reload()
        })
    },
    [addToast],
  )

  return { submitting, sendForm }
}
